(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["airlo-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const popup = document.querySelector('[data-airlo-popup]');
      if (!popup || popup.dataset.initialized) return;
      popup.dataset.initialized = 'true';
      const storage = {get:key=>{try{return localStorage.getItem(key)}catch{return null}},set:(key,value)=>{try{localStorage.setItem(key,value)}catch{}}};
      const dismissedKey = 'airlo-signup-dismissed-v1';
      const subscribedKey = 'airlo-signup-complete-v1';
      const open = () => {if(!popup.open && typeof popup.showModal === 'function') popup.showModal();};
      const close = () => {popup.close(); storage.set(dismissedKey,String(Date.now()));};
      document.querySelectorAll('[data-airlo-signup]').forEach(button=>button.addEventListener('click',open));
      popup.querySelectorAll('[data-airlo-close]').forEach(button=>button.addEventListener('click',close));
      popup.addEventListener('cancel',()=>storage.set(dismissedKey,String(Date.now())));
      popup.addEventListener('click',event=>{if(event.target===popup){const box=popup.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)close();}});
      document.querySelectorAll('[data-airlo-copy]').forEach(button=>button.addEventListener('click',async()=>{try{await navigator.clipboard.writeText('AIRLO10');button.textContent=button.dataset.copied}catch{button.closest('.airlo-code').querySelector('strong').focus()}}));
      if(document.querySelector('[data-airlo-signed-up]')) {storage.set(subscribedKey,'true'); if(location.hash.includes('popup'))open(); return;}
      if(popup.querySelector('[data-airlo-form-error]')) {open(); return;}
      if(window.Shopify?.designMode || popup.dataset.subscribed || storage.get(subscribedKey)) return;
      if(Date.now()-Number(storage.get(dismissedKey)||0)<7*24*60*60*1000) return;
      window.setTimeout(()=>{if(!document.querySelector('dialog[open]')&&!['INPUT','TEXTAREA','SELECT'].includes(document.activeElement?.tagName))open()},Number(popup.dataset.delay||10)*1000);
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
    document.addEventListener('shopify:section:load',init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
